unit View.Certificados.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewCertificadosEdit = class(TWebForm)
    pnlMessage: TWebPanel;
    lbMessage: TWebLabel;
    btCloseMessage: TWebButton;
    DataSource: TWebDatasource;
    btCancel: TWebButton;
    btSave: TWebButton;
    btDelete: TWebButton;
    lbid: TWebLabel;
    edid: TWebDBEdit;
    lbaliado_id: TWebLabel;
    edaliado_id: TWebDBEdit;
    lbnumero_serie: TWebLabel;
    ednumero_serie: TWebDBEdit;
    lbdata_vencimento: TWebLabel;
    eddata_vencimento: TWebDBEdit;
    lbsenha: TWebLabel;
    edsenha: TWebDBEdit;
    lbcertificado_s3: TWebLabel;
    edcertificado_s3: TWebDBEdit;
    lbinclusao: TWebLabel;
    edinclusao: TWebDBEdit;
    lbalteracao: TWebLabel;
    edalteracao: TWebDBEdit;
    XDataClientCertificadosGet: TXDataWebClient;
    XDataClientCertificadosDelete: TXDataWebClient;
    CertificadosDataset: TXDataWebDataSet;
    CertificadosDatasetid: TIntegerField;
    CertificadosDatasetaliado_id: TIntegerField;
    CertificadosDatasetnumero_serie: TStringField;
    CertificadosDatasetdata_vencimento: TDateTimeField;
    CertificadosDatasetsenha: TStringField;
    CertificadosDatasetcertificado_s3: TStringField;
    CertificadosDatasetinclusao: TDateTimeField;
    CertificadosDatasetalteracao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientCertificadosGetLoad(Response: TXDataClientResponse);
    procedure XDataClientCertificadosDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientCertificadosDeleteError(Error: TXDataClientError);
    procedure CertificadosDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TWebForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TWebForm; overload;
  end;

var
  FViewCertificadosEdit: TFViewCertificadosEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewCertificadosEdit }

procedure TFViewCertificadosEdit.btSaveClick(Sender: TObject);
begin
  if CertificadosDataset.State in dsEditModes then
  begin
        CertificadosDataset.Post;
    CertificadosDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewCertificadosEdit.btDeleteClick(Sender: TObject);
begin
  if CertificadosDataset.State in dsEditModes then
    CertificadosDataset.Post;
  XDataClientCertificadosDelete.Delete(CertificadosDataset.EntitySetName,
    TJSObject(CertificadosDataset.CurrentData));
end;


class function TFViewCertificadosEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TWebForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewCertificadosEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewCertificadosEdit.InsertEntity;
begin
  CertificadosDataset.Close;
  CertificadosDataset.SetJsonData('{}');
  CertificadosDataset.Open;
  CertificadosDataset.Insert;
end;

class function TFViewCertificadosEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TWebForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewCertificadosEdit(AForm).FInserting := AInserting;
    TFViewCertificadosEdit(AForm).FId := AId;
    TFViewCertificadosEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewCertificadosEdit(AForm).InsertEntity
    else
      TFViewCertificadosEdit(AForm).LoadEntity;
    TFViewCertificadosEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewCertificadosEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewCertificadosEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    CertificadosDataset.Connection.Model.DefaultSchema.FindEntityType(
      CertificadosDataset.EntitySetName
    )
  );
  XDataClientCertificadosGet.Get(CertificadosDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewCertificadosEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewCertificadosEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewCertificadosEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewCertificadosEdit.XDataClientCertificadosGetLoad(Response: TXDataClientResponse);
begin
  CertificadosDataset.Close;
  CertificadosDataset.SetJsonData(Response.Result);
  CertificadosDataset.Open;
  
  CertificadosDataset.Edit;  
end;

procedure TFViewCertificadosEdit.XDataClientCertificadosDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewCertificadosEdit.XDataClientCertificadosDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewCertificadosEdit.CertificadosDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewCertificadosEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

end.
